module.exports = __webpack_public_path__ + "assets/img/6_655.b9757f51.jpg";